import React from 'react';

interface LayerTextColorToggleProps {
  textColor: boolean; // true = dark (#000), false = light (#fff)
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

export const LayerTextColorToggle: React.FC<LayerTextColorToggleProps> = ({
  textColor,
  onChange,
  disabled = false,
}) =>
{
  return (
    <button
      type="button"
      title={
        textColor ? 'Dark text (click to switch to light)' : 'Light text (click to switch to dark)'
      }
      disabled={disabled}
      onClick={() => onChange(!textColor)}
      className="w-[26px] h-[26px] rounded flex items-center justify-center text-sm font-bold border border-[#ccc] select-none transition-colors disabled:opacity-40 disabled:cursor-default focus:outline focus:outline-2 focus:outline-[#62aacb]"
      style={{
        backgroundColor: textColor ? '#000000' : '#ececec',
        color: textColor ? '#ffffff' : '#000000',
      }}
    >
      A
    </button>
  );
};
